import { FC } from 'react';
import { DefaultCell } from '@silverfort/sf-components';
import { getDateShortFormat } from '../../../../../utils/dates';

interface Props {
    lastSeen?: Date;
}

const LastSeenCell: FC<Props> = ({ lastSeen }) => {
    return <DefaultCell text={lastSeen ? getDateShortFormat(lastSeen) : 'N/A'} />;
};

export default LastSeenCell;
